import * as CustomAxios from './CustomAxios'

const ReportError = {

  notifyReportError: (details: any) =>
    CustomAxios.requests.post<any>(process.env.REACT_APP_API_URL + `/api/ReportError/Add`, details),
}

const WebUser = {

  requestLogin: (value: any) => CustomAxios.requests.put<any>(process.env.REACT_APP_API_URL + `/api/WebUser/Login`, value),
  forgotPassword: (value: any) => CustomAxios.requests.put<any>(process.env.REACT_APP_API_URL + `/api/WebUser/ForgotPassword`, value),
  confirmAccount: (value: any) => CustomAxios.requests.put<any>(process.env.REACT_APP_API_URL + `/api/WebUser/ConfirmAccount`, value),
  resetPassword: (value: any) => CustomAxios.requests.put<any>(process.env.REACT_APP_API_URL + `/api/WebUser/ResetPassword`, value),

  createAccount: (value: any) => CustomAxios.requests.post<any>(process.env.REACT_APP_API_URL + `/api/WebUser/CreateAccount`, value),

  getAccountDetails: (userNo: number) =>
    CustomAxios.requests.get<any>(process.env.REACT_APP_API_URL + `/api/WebUser/Details/${userNo}`),
  updateAccountDetails: (value: any) => CustomAxios.requests.put<any>(process.env.REACT_APP_API_URL + `/api/WebUser/UpdateAccount`, value),

  getAppVersion: () => CustomAxios.requests.get<any>(process.env.REACT_APP_API_URL + `/api/WebUser/Version`),
}

const Postcode = {

  getSuburbByKeyword: (keyword: string) =>
    CustomAxios.requests.get<any>(process.env.REACT_APP_API_URL + `/api/Postcode/Search/${keyword}`),
}


const WholeHome= {

  getSalesDashboard: (userNo: number, wholeNo: number) =>
    CustomAxios.requests.get<any>(process.env.REACT_APP_API_URL + `/api/WholeHome/SalesDashboard/${userNo}/${wholeNo}`),
  getProductDashboard: (userNo: number, wholeNo: number) =>
    CustomAxios.requests.get<any>(process.env.REACT_APP_API_URL + `/api/WholeHome/ProductDashboard/${userNo}/${wholeNo}`),
  getCustomerDashboard: (userNo: number, wholeNo: number) =>
    CustomAxios.requests.get<any>(process.env.REACT_APP_API_URL + `/api/WholeHome/CustomerDashboard/${userNo}/${wholeNo}`),
}

const WholeCustomer = {

  getCustomerList: (userNo: number, role: number, roleRefNo: number, status: string) =>
    CustomAxios.requests.get<any>(process.env.REACT_APP_API_URL + `/api/WholeCustomer/List/${userNo}/${role}/${roleRefNo}/${status}`),
  getCustomerDialog: (userNo: number, customerNo: number) =>
    CustomAxios.requests.get<any>(process.env.REACT_APP_API_URL + `/api/WholeCustomer/Dialog/${userNo}/${customerNo}`),
  addCustomer: (details: any) =>
    CustomAxios.requests.post<any>(process.env.REACT_APP_API_URL + `/api/WholeCustomer/Add`, details),
  updateCustomer: (details: any) =>
    CustomAxios.requests.put<any>(process.env.REACT_APP_API_URL + `/api/WholeCustomer/Update`, details),
  
  getActiveCustomers: (wholeNo: number) =>
    CustomAxios.requests.get<any>(process.env.REACT_APP_API_URL + `/api/WholeCustomer/Active/${wholeNo}`),

  getActivePendCustomers: (wholeNo: number) =>
    CustomAxios.requests.get<any>(process.env.REACT_APP_API_URL + `/api/WholeCustomer/ActivePend/${wholeNo}`),
}

const WholeCustomerStaff = {

  getStaffList: (userNo: number, customerNo: number) =>
    CustomAxios.requests.get<any>(process.env.REACT_APP_API_URL + `/api/WholeCustomerStaff/List/${userNo}/${customerNo}`),

  addStaffToCustomer: (details: any) =>
    CustomAxios.requests.post<any>(process.env.REACT_APP_API_URL + `/api/WholeCustomerStaff/Add`, details),
  deleteStaffFromCustomer: (details: any) =>
    CustomAxios.requests.put<any>(process.env.REACT_APP_API_URL + `/api/WholeCustomerStaff/Delete`, details),
}

const WholeSubStore = {

  getSubStoreList: (userNo: number, customerNo: number) =>
    CustomAxios.requests.get<any>(process.env.REACT_APP_API_URL + `/api/WholeSubStore/List/${userNo}/${customerNo}`),
  getSubStoreForDialog: (userNo: number, customerNo: number) =>
    CustomAxios.requests.get<any>(process.env.REACT_APP_API_URL + `/api/WholeSubStore/Dialog/${userNo}/${customerNo}`),
  addSubStore: (details: any) =>
    CustomAxios.requests.post<any>(process.env.REACT_APP_API_URL + `/api/WholeSubStore/Add`, details),
  updateSubStore: (details: any) =>
    CustomAxios.requests.put<any>(process.env.REACT_APP_API_URL + `/api/WholeSubStore/Update`, details),
  deleteSubStore: (details: any) =>
    CustomAxios.requests.put<any>(process.env.REACT_APP_API_URL + `/api/WholeSubStore/Delete`, details),

  transferSubStore: (details: any) =>
    CustomAxios.requests.put<any>(process.env.REACT_APP_API_URL + `/api/WholeSubStore/Transfer`, details),

  getSubStoreDetails: (subStoreNo: number) =>
    CustomAxios.requests.get<any>(process.env.REACT_APP_API_URL + `/api/WholeSubStore/SubStore/${subStoreNo}`),
}

const WholeProduct = {

  getProductList: (userNo: number, role: number, roleRefNo: number, status: string) =>
    CustomAxios.requests.get<any>(process.env.REACT_APP_API_URL + `/api/WholeProduct/List/${userNo}/${role}/${roleRefNo}/${status}`),
  getAvailProductList: (userNo: number, role: number, roleRefNo: number) =>
    CustomAxios.requests.get<any>(process.env.REACT_APP_API_URL + `/api/WholeProduct/Avail/${userNo}/${role}/${roleRefNo}`),
  getProductDialog: (userNo: number, roleRefNo: number, prodId: number, needClasses: boolean,) =>
    CustomAxios.requests.get<any>(process.env.REACT_APP_API_URL + `/api/WholeProduct/Dialog/${userNo}/${roleRefNo}/${prodId}?needClasses=${needClasses}`),
  addProduct: (details: any) =>
    CustomAxios.requests.post<any>(process.env.REACT_APP_API_URL + `/api/WholeProduct/Add`, details),
  updateProduct: (details: any) =>
    CustomAxios.requests.put<any>(process.env.REACT_APP_API_URL + `/api/WholeProduct/Update`, details),
  deleteProduct: (details: any) =>
    CustomAxios.requests.put<any>(process.env.REACT_APP_API_URL + `/api/WholeProduct/Delete`, details),


  uploadImportExcelFile: (details: any) =>
    CustomAxios.requests.put<any>(process.env.REACT_APP_API_URL + `/api/WholeProduct/UploadImportExcelFile`, details),
  importProductList: (details: any) =>
    CustomAxios.requests.post<any>(process.env.REACT_APP_API_URL + `/api/WholeProduct/ImportProductList`, details),

  updateProductImage: (details: any) =>
    CustomAxios.requests.put<any>(process.env.REACT_APP_API_URL + `/api/WholeProduct/UpdateImage`, details),

  getProductSoldHistory: (userNo: number, roleRefNo: number, prodId: number) =>
    CustomAxios.requests.get<any>(process.env.REACT_APP_API_URL + `/api/WholeProduct/History/${userNo}/${roleRefNo}/${prodId}`),
}

const WholeProductPrice = {
  
  getProductPriceHistory: (userNo: number, roleRefNo: number, prodId: number) =>
    CustomAxios.requests.get<any>(process.env.REACT_APP_API_URL + `/api/WholeProductPrice/History/${userNo}/${roleRefNo}/${prodId}`),
}

const WholeStockCount = {
  
  getStockCountHistory: (userNo: number, roleRefNo: number, prodId: number) =>
    CustomAxios.requests.get<any>(process.env.REACT_APP_API_URL + `/api/WholeStockCount/History/${userNo}/${roleRefNo}/${prodId}`),

  addStockCount: (details: any) =>
    CustomAxios.requests.post<any>(process.env.REACT_APP_API_URL + `/api/WholeStockCount/AddStockCount`, details),
}

const WholeProductClass  = {

  getProductClasses: (userNo: number, wholeNo: number) =>
    CustomAxios.requests.get<any>(process.env.REACT_APP_API_URL + `/api/WholeProductClass/List/${userNo}/${wholeNo}`),
  addProductClass: (details: any) =>
    CustomAxios.requests.post<any>(process.env.REACT_APP_API_URL + `/api/WholeProductClass/Add`, details),
  updateProductClass: (details: any) =>
    CustomAxios.requests.put<any>(process.env.REACT_APP_API_URL + `/api/WholeProductClass/Update`, details),
  deleteProductClass: (details: any) =>
    CustomAxios.requests.put<any>(process.env.REACT_APP_API_URL + `/api/WholeProductClass/Delete`, details),
}


const WholeSales = {

  getSalesOrderList: (wholeNo: number, customerNo: number, mode: string, filter: string) =>
    CustomAxios.requests.get<any>(process.env.REACT_APP_API_URL + `/odata/WholeOrder?wholeNo=${wholeNo}&customerNo=${customerNo}&mode=${mode}&$count=true&${filter}`),

  updateOrderDetails: (details: any) =>
    CustomAxios.requests.put<any>(process.env.REACT_APP_API_URL + `/api/WholeOrder/UpdateDetails`, details),

  getOrderItemsForDialog: (userNo: number, wholeNo: number, orderId: number) =>
    CustomAxios.requests.get<any>(process.env.REACT_APP_API_URL + `/api/WholeOrder/Dialog/${userNo}/${wholeNo}/${orderId}`),

  getSalesOrderById: (wholeNo: number, orderId: number) =>
    CustomAxios.requests.get<any>(process.env.REACT_APP_API_URL + `/api/WholeOrder/OrderById/${wholeNo}/${orderId}`),

  addOrderItem: (details: any) =>
    CustomAxios.requests.put<any>(process.env.REACT_APP_API_URL + `/api/WholeOrder/AddItem`, details),
  updateOrderItem: (details: any) =>
    CustomAxios.requests.put<any>(process.env.REACT_APP_API_URL + `/api/WholeOrder/UpdateItem`, details),
  deleteOrderItem: (details: any) =>
    CustomAxios.requests.put<any>(process.env.REACT_APP_API_URL + `/api/WholeOrder/DeleteItem`, details),

  getPrintableOrders: (wholeNo: number, details: any) =>
    CustomAxios.requests.put<any>(process.env.REACT_APP_API_URL + `/api/WholeOrder/Print/${wholeNo}`, details),

  updateBulkOrderStatus: (details: any) =>
    CustomAxios.requests.put<any>(process.env.REACT_APP_API_URL + `/api/WholeOrder/UpdateBulkStatus`, details),

  addOrderByWholesaler: (details: any) =>
    CustomAxios.requests.post<any>(process.env.REACT_APP_API_URL + `/api/WholeOrder/AddOrder`, details),
  addOrderItemsByWholesaler: (details: any) =>
    CustomAxios.requests.post<any>(process.env.REACT_APP_API_URL + `/api/WholeOrder/AddItems`, details),
}

const WholeAdmin = {

  getWholesalerDetails: (wholeNo: number) =>
    CustomAxios.requests.get<any>(process.env.REACT_APP_API_URL + `/api/WholeAdmin/Details/${wholeNo}`), 
  updateWholesalerDetails: (details: any) =>
    CustomAxios.requests.put<any>(process.env.REACT_APP_API_URL + `/api/WholeAdmin/Update`, details),
}

const WholeAdminAccount  = {

  getAccountList: (userNo: number, wholeNo: number) =>
    CustomAxios.requests.get<any>(process.env.REACT_APP_API_URL + `/api/WholeAccount/List/${userNo}/${wholeNo}`),
  addAccount: (details: any) =>
    CustomAxios.requests.post<any>(process.env.REACT_APP_API_URL + `/api/WholeAccount/Add`, details),
  updateAccount: (details: any) =>
    CustomAxios.requests.put<any>(process.env.REACT_APP_API_URL + `/api/WholeAccount/Update`, details),
  deleteAccount: (details: any) =>
    CustomAxios.requests.put<any>(process.env.REACT_APP_API_URL + `/api/WholeAccount/Delete`, details),

  getDriverList: (userNo: number, wholeNo: number) =>
    CustomAxios.requests.get<any>(process.env.REACT_APP_API_URL + `/api/WholeAccount/Drivers/${userNo}/${wholeNo}`),
}

const WholeAdminVehicle  = {

  getVehicleList: (userNo: number, wholeNo: number) =>
    CustomAxios.requests.get<any>(process.env.REACT_APP_API_URL + `/api/WholeVehicle/List/${userNo}/${wholeNo}`),
  addVehicle: (details: any) =>
    CustomAxios.requests.post<any>(process.env.REACT_APP_API_URL + `/api/WholeVehicle/Add`, details),
  updateVehicle: (details: any) =>
    CustomAxios.requests.put<any>(process.env.REACT_APP_API_URL + `/api/WholeVehicle/Update`, details),
  deleteVehicle: (details: any) =>
    CustomAxios.requests.put<any>(process.env.REACT_APP_API_URL + `/api/WholeVehicle/Delete`, details),

  getAvailVehicleList: (userNo: number, wholeNo: number) =>
    CustomAxios.requests.get<any>(process.env.REACT_APP_API_URL + `/api/WholeVehicle/Available/${userNo}/${wholeNo}`),
}


const WholeFavourite = {

  getCustomerFavourites: (wholeNo: number, custNo: number, prodId: number) =>
    CustomAxios.requests.get<any>(process.env.REACT_APP_API_URL + `/api/WholeFavourite/Customer/${wholeNo}/${custNo}/${prodId}`),
  addCustomerFavourite: (details: any) =>
    CustomAxios.requests.post<any>(process.env.REACT_APP_API_URL + `/api/WholeFavourite/Add`, details),
  addBulkCustomerFavourites: (details: any) =>
    CustomAxios.requests.post<any>(process.env.REACT_APP_API_URL + `/api/WholeFavourite/AddBulk`, details),
  deleteCustomerFavourite: (details: any) =>
    CustomAxios.requests.put<any>(process.env.REACT_APP_API_URL + `/api/WholeFavourite/Delete`, details),

  uploadImportExcelFile: (details: any) =>
    CustomAxios.requests.put<any>(process.env.REACT_APP_API_URL + `/api/WholeFavourite/UploadImportExcelFile`, details),
  importProductList: (details: any) =>
    CustomAxios.requests.post<any>(process.env.REACT_APP_API_URL + `/api/WholeFavourite/ImportFavouriteList`, details),

  addSkuList: (details: any) =>
    CustomAxios.requests.post<any>(process.env.REACT_APP_API_URL + `/api/WholeFavourite/AddSkuList`, details),
}

const WholeChat = {

  getChatRoomList: (userNo: number, wholeNo: number) =>
    CustomAxios.requests.get<any>(process.env.REACT_APP_API_URL + `/api/WholeChat/RoomList/${userNo}/${wholeNo}`),
  getChatHistoryWithCustomer: (wholeNo: number, custNo: number, chatRoomId: number) =>
    CustomAxios.requests.get<any>(process.env.REACT_APP_API_URL + `/api/WholeChat/HistoryWithCustomer/${wholeNo}/${custNo}/${chatRoomId}`),
  
  addChat: (details: any) =>
    CustomAxios.requests.post<any>(process.env.REACT_APP_API_URL + `/api/WholeChat/Add`, details),
  deleteChat: (details: any) =>
    CustomAxios.requests.put<any>(process.env.REACT_APP_API_URL + `/api/WholeChat/Delete`, details),

  addGroupChat: (details: any) =>
    CustomAxios.requests.post<any>(process.env.REACT_APP_API_URL + `/api/WholeChat/AddGroup`, details),
}

const WholePermission = {

  getPermissionSmartOrder: (userNo: number, wholeNo: number) =>
    CustomAxios.requests.get<any>(process.env.REACT_APP_API_URL + `/api/WholePermission/SmartOrder/${userNo}/${wholeNo}`),
}

const WholeSmartOrder = {

  getFindMatchItems: (details: any) =>
    CustomAxios.requests.post<any>(process.env.REACT_APP_API_URL + `/api/WholeSmartOrder/MatchItems`, details),

  addSmartOrderByWholesaler: (details: any) =>
    CustomAxios.requests.post<any>(process.env.REACT_APP_API_URL + `/api/WholeSmartOrder/AddSmartOrder`, details),
}


const CustomerHome = {

  getHomeLatestOrders: (userNo: number, roleRefNo: number) =>
    CustomAxios.requests.get<any>(process.env.REACT_APP_API_URL + `/api/CustomerHome/LatestOrder/${userNo}/${roleRefNo}`),
  getHomeDiscountProducts: (customerNo: number, wholeNo: number) =>
    CustomAxios.requests.get<any>(process.env.REACT_APP_API_URL + `/api/CustomerHome/DiscountProducts/${customerNo}/${wholeNo}`),
  getHomeNewProducts: (userNo: number, roleRefNo: number) =>
    CustomAxios.requests.get<any>(process.env.REACT_APP_API_URL + `/api/CustomerHome/NewProducts/${userNo}/${roleRefNo}`),
  getHomeWholesalerInfo: (customerNo: number) =>     
    CustomAxios.requests.get<any>(process.env.REACT_APP_API_URL + `/api/CustomerHome/WholesalerInfo/${customerNo}`),  
}

const CustomerProduct = {

  getProductList: (userNo: number, roleRefNo: number) =>
    CustomAxios.requests.get<any>(process.env.REACT_APP_API_URL + `/api/CustomerProduct/List/${userNo}/${roleRefNo}`),
  getProductDialog: (userNo: number, roleRefNo: number, prodId: number) =>
    CustomAxios.requests.get<any>(process.env.REACT_APP_API_URL + `/api/CustomerProduct/Dialog/${userNo}/${roleRefNo}/${prodId}`),
}

const CustomerFavourite = {

  getMyFavouriteList: (userNo: number, roleRefNo: number) =>
    CustomAxios.requests.get<any>(process.env.REACT_APP_API_URL + `/api/CustomerFavourite/MyList/${userNo}/${roleRefNo}`),
  addMyFavourite: (details: any) =>
    CustomAxios.requests.post<any>(process.env.REACT_APP_API_URL + `/api/CustomerFavourite/Add`, details),
  deleteMyFavourite: (details: any) =>
    CustomAxios.requests.put<any>(process.env.REACT_APP_API_URL + `/api/CustomerFavourite/Delete`, details),
}

const CustomerOrder = {

  checkOutofStockItems: (details: any) =>
    CustomAxios.requests.put<any>(process.env.REACT_APP_API_URL + `/api/CustomerOrder/CheckOutofStock`, details),

  addCustomerOrder: (details: any) =>
    CustomAxios.requests.post<any>(process.env.REACT_APP_API_URL + `/api/CustomerOrder/Add`, details),

  getSalesOrdersLast2Months: (userNo: number, roleRefNo: number) =>
    CustomAxios.requests.get<any>(process.env.REACT_APP_API_URL + `/api/CustomerOrder/Last2Months/${userNo}/${roleRefNo}`),

  getSalesOrdersMore1Month: (userNo: number, roleRefNo: number, requestMonth: number) =>
    CustomAxios.requests.get<any>(process.env.REACT_APP_API_URL + `/api/CustomerOrder/More1Month/${userNo}/${roleRefNo}/${requestMonth}`),

  getOrderItemList: (userNo: number, roleRefNo: number, orderId: number) =>
    CustomAxios.requests.get<any>(process.env.REACT_APP_API_URL + `/api/CustomerOrder/OrderItems/${userNo}/${roleRefNo}/${orderId}`),
}

const CustomerChat = {

  getPendingCount: (customerNo: number, wholeNo: number) =>
    CustomAxios.requests.get<any>(process.env.REACT_APP_API_URL + `/api/CustomerChat/PendingCount/${customerNo}/${wholeNo}`),
  getCustomerChatHistory: (customerNo: number, wholeNo: number) =>
    CustomAxios.requests.get<any>(process.env.REACT_APP_API_URL + `/api/CustomerChat/CustomerHistory/${customerNo}/${wholeNo}`),
}

const TodayDelivery = {

  getTodayDeliveryList: (userNo: number, wholeNo: number) =>
    CustomAxios.requests.get<any>(process.env.REACT_APP_API_URL + `/api/TodayDelivery/List/${userNo}/${wholeNo}`),

  updateTodaySchedule: (details: any) =>
    CustomAxios.requests.put<any>(process.env.REACT_APP_API_URL + `/api/TodayDelivery/Update`, details),

  deleteColumnSchedule: (details: any) =>
    CustomAxios.requests.put<any>(process.env.REACT_APP_API_URL + `/api/TodayDelivery/Delete`, details),

  sendEmailSchedule: (details: any) =>
    CustomAxios.requests.put<any>(process.env.REACT_APP_API_URL + `/api/TodayDelivery/Email`, details),
  confirmColumnSchedule: (details: any) =>
    CustomAxios.requests.put<any>(process.env.REACT_APP_API_URL + `/api/TodayDelivery/Confirm`, details),

  getCardListByColumn: (strScheduleId: string) =>
    CustomAxios.requests.get<any>(process.env.REACT_APP_API_URL + `/api/TodayDelivery/CardList/${strScheduleId}`),

  getCardDetails: (strDeliveryId: string) =>
    CustomAxios.requests.get<any>(process.env.REACT_APP_API_URL + `/api/TodayDelivery/Card/${strDeliveryId}`),
  updateDeliveryCard: (details: any) =>
    CustomAxios.requests.put<any>(process.env.REACT_APP_API_URL + `/api/TodayDelivery/UpdateCard`, details),
  deleteDeliveryCard: (details: any) =>
    CustomAxios.requests.put<any>(process.env.REACT_APP_API_URL + `/api/TodayDelivery/DeleteCard`, details),

  getTodayDepartOrder: () =>
    CustomAxios.requests.get<any>(process.env.REACT_APP_API_URL + `/api/TodayDelivery/DepartOrderList`),
  updateDepartOrder: (details: any) =>
    CustomAxios.requests.put<any>(process.env.REACT_APP_API_URL + `/api/TodayDelivery/UpdateDepartOrder`, details),
}

const DeliveryHistory = {

  getHistoryList: (startDate: string, endDate: string, filter: string) =>
    CustomAxios.requests.get<any>(process.env.REACT_APP_API_URL + `/odata/DeliveryHistory?startDate=${startDate}&endDate=${endDate}&$count=true&${filter}`),
}

const ApiAgent = {
  ReportError,
  WebUser,
  Postcode,

  WholeHome,
  WholeCustomer,
  WholeCustomerStaff,
  WholeSubStore,
  WholeProduct,
  WholeProductClass,
  WholeProductPrice,
  WholeStockCount,
  WholeSales,
  WholeAdmin,
  WholeAdminAccount,
  WholeAdminVehicle,
  WholeFavourite,
  WholeChat,
  WholePermission,
  WholeSmartOrder,

  TodayDelivery,
  DeliveryHistory,

  CustomerHome,
  CustomerProduct,
  CustomerFavourite,
  CustomerOrder,
  CustomerChat,

}

export default ApiAgent;
